<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-09-10                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container style="margin-top: 70px">
    <b-row>
      <b-col sm="12" md="12" lg="8" xl="8">
        <configuration-dialog :template-version="template_version"
                              :quote-product="quote_product"
                              :is-public="isPublic"></configuration-dialog>
      </b-col>
      <b-col sm="12" md="12" lg="4" xl="4">
        <div class="position-sticky" style="top:70px">
          <configuration-summary :template-version="template_version"
                                 :quote-product="quote_product"
                                 :price-name="summaryPriceName"
                                 :debug-enabled="debugEnabled"></configuration-summary>
          <configuration-dialog-buttons :quote-product="quote_product" :is-public="isPublic" :is-bto="true"></configuration-dialog-buttons>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ConfigurationDialog from "./configuration-dialog.vue";
import ConfigurationSummary from "./configuration-summary.vue";
import ConfigurationDialogButtons from "./configuration-dialog-buttons.vue";
import ConfigureMixin from "./configure-mixin";

export default {
  name: "configure-bto",
  mixins: [ConfigureMixin],
  components: {ConfigurationDialogButtons, ConfigurationSummary, ConfigurationDialog},
  props: {
    dialogPricesList:{
      type:Array,
      default(){
        return [];
      }
    },
    dialogAttributesList:{
      type: Array,
      default(){
        return [];
      }
    },
    summaryPriceName:{
      type:String,
      required: true
    },
    isPublic:{
      type: Boolean,
      default: false
    },
    debugEnabled:{
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
